import axios from 'axios';
import { getApiUrl } from '../../../settings';
import { getAccessToken } from '../../authApi';

export const reorderBanners = async (bannerIds: number[]) => {
  const bearerToken = getAccessToken();
  const apiUrl = await getApiUrl();

  const response = await axios.request({
    method: 'POST',
    url: `${apiUrl}/api/v1/system/smartbanners/reorder`,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
    data: {
      banner_ids: bannerIds,
    },
  });

  return response;
};

export default reorderBanners;
